import { render, staticRenderFns } from "./CargoSalesAnalysis.vue?vue&type=template&id=50c3bd10"
import script from "./CargoSalesAnalysis.vue?vue&type=script&lang=js"
export * from "./CargoSalesAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports